export const filterMenuByPermissions = (menuItems, userPermissions) => {
  if (!userPermissions || !Array.isArray(userPermissions) || userPermissions.length === 0) {
    return [];
  }

  // Permission format: { "ripening": "ripening.sorting" }
  // permissionConfig uses: permission_module="ripening", permission_key="ripening_sorting"
  // Backend uses dots: "ripening.sorting" — so convert underscore key to dot format for matching
  const hasPermission = (module, permissionKey) => {
    // Convert "ripening_sorting" → "ripening.sorting" to match backend format
    const dotKey = permissionKey.replace(/_/g, '.');
    // Also try exact match for keys like "refrigeration" or "cleaning"
    return userPermissions.some(perm => {
      const permValue = Object.values(perm)[0]; // e.g. "ripening.sorting"
      return permValue === dotKey || permValue === permissionKey;
    });
  };

  return menuItems.filter(menuItem => {
    // Always show dashboard
    if (menuItem.permission_key === "all") {
      return true;
    }

    if (menuItem.subMenu && menuItem.subMenu.length > 0) {
      const filteredSubMenu = menuItem.subMenu.filter(subItem =>
        hasPermission(menuItem.permission_module, subItem.permission_key)
      );
      return filteredSubMenu.length > 0;
    } else {
      return hasPermission(menuItem.permission_module, menuItem.permission_key);
    }
  }).map(menuItem => {
    if (menuItem.subMenu && menuItem.subMenu.length > 0) {
      const filteredSubMenu = menuItem.subMenu.filter(subItem =>
        hasPermission(menuItem.permission_module, subItem.permission_key)
      );
      return { ...menuItem, subMenu: filteredSubMenu };
    }
    return menuItem;
  });
};
